import { SectionSkeleton } from 'components/shared/MultiStepForm/Skeletons/SectionSkeleton';

export const EmployerCostSettingsSkeleton = () => (
  <>
    <SectionSkeleton height={200} />
    <SectionSkeleton height={300} />
  </>
);
